import styled from 'styled-components';
import { TextArea as _TextArea } from 'components/Inputs';
import { sizes } from 'style';

export const DescriptionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row-reverse;
    gap: 20px;
  }
`;

export const TextArea = styled(_TextArea)`
  > textarea {
    height: 200px;
    margin-top: 1px;
    resize: vertical;

    @media ${sizes.tabletPortrait} {
      height: 100%;
    }

    @media ${sizes.mediumLargeDesktop} {
      height: 186px;
    }
  }

  @media ${sizes.tabletPortrait} {
    flex: 1;
  }
`;
